import { requests } from './index'

type getCloud4PackageProposalType = (parameters: {[key: string]: number | string | boolean | any | any[]}) => Promise<string>;
type getAllTariffPackagesType = () => Promise<string>
type getProductDetailType = (productId: number) => Promise<any>
type getIsValidIbanType = (iban: string) => Promise<string>
type getCloudToGoPowerConsumptionType = (query: { [key: string]: number }) => Promise<string>
type getElectricityGridOperatorType = (postalCode: string) => Promise<string>
type getCitiesByPostalCodeType = (postalCode: string) => Promise<Array<{ id: number, name: string, postcode: string}>>
type getStreetsByCityNameType = (postalCode: string, cityName: string) => Promise<Array<string>>

/**
 * Returns a SENEC.Cloud 4 tariff package proposal
 */
export const getCload4PackageProposal: getCloud4PackageProposalType = (parameters) => {
  const params = {
    query: JSON.stringify(parameters),
    name: 'getCloud4PackageProposals'
  }

  return requests.postApi<string, {query: string; name: string;}>(params)
}

/**
 * Returns all available SENEC.Cloud 3.0 tariff packages
 */
export const getAllTariffPackages: getAllTariffPackagesType = () => {
  const params = {
    name: 'allTariffPackages'
  }

  return requests.postApi<string, {name: string}>(params)
}

/**
 * Returns specific SENEC system product
 */
export const getProductDetail: getProductDetailType = (productId) => {
  const params = {
    name: 'getProductDetail',
    productId
  }

  return requests.postApi<any, {name:string; productId: number;}>(params)
}

/**
 * Validates a SENEC.Cloud 3.0 voucher code
 */
export const getIsValidIban: getIsValidIbanType = (iban) => {
  const params = {
    name: 'isValidIban',
    iban
  }

  return requests.postApi<string, {name: string; iban: string}>(params)
}

/**
 * Returns the calculated annual power consumption for Cloud To Go package
 */
export const getCloudToGoPowerConsumption: getCloudToGoPowerConsumptionType = (parameters) => {
  const params = {
    query: JSON.stringify(parameters),
    name: 'getCloudToGoPowerConsumption'
  }

  return requests.postApi<string, {query: string; name: string;}>(params)
}

/**
 * Gets the Electricity grid operators for a certain postal code.
 */
export const getElectricityGridOperator: getElectricityGridOperatorType = (postalCode) => {
  const params = {
    query: JSON.stringify({ 'postal-code': postalCode }),
    name: 'getElectricityGridOperator'
  }

  return requests.postApi<string, {query: string, name: string}>(params)
}

/**
 * Gets cities by ZIP code.
 */
export const getCitiesByPostalCode: getCitiesByPostalCodeType = (postalCode) => {
  const params = {
    postcode: postalCode,
    name: 'getCities'
  }
  return requests.postApi<Array<{ id: number, name: string, postcode: string}>, {postcode: string, name: string}>(params)
}

/**
 * Gets streets by city name.
 */
export const getStreetsByPostalCodeAndCityName: getStreetsByCityNameType = (postalCode, cityName) => {
  const params = {
    postal_code: postalCode,
    city_name: cityName,
    name: 'getStreets'
  }
  return requests.postApi<Array<string>, {postal_code: string, city_name: string, name: string}>(params)
}

/**
 * SENEC Cloud 3.0 application POST
 */
export const applicationPost = (parameters: any) => {
  const params = {
    query: JSON.stringify(parameters),
    name: 'application'
  }
  return requests.postApi(params)
}
